import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  InfiniteData,
} from "@tanstack/react-query";
import { axiosInterceptor } from "..";
import { AxiosError } from "axios";
import { StudentsResponse } from "../interface";

interface QueryParams {
  firstName?: string;
  lastName?: string;
  email?: string;
  limit?: number;
}

export type StudentsInfiniteData = InfiniteData<StudentsResponse>;

const useStudentsStats = (
  organizationId: string | undefined,
  params: QueryParams,
  options?: Partial<
    UseInfiniteQueryOptions<StudentsResponse, AxiosError, StudentsInfiniteData>
  >
) => {
  return useInfiniteQuery<StudentsResponse, AxiosError, StudentsInfiniteData>({
    queryKey: ["students", organizationId, params],
    queryFn: async ({ pageParam = 1 }) => {
      if (!organizationId) {
        throw new Error("Organization ID is required");
      }

      const response = await axiosInterceptor.get<StudentsResponse>(
        `/organizations/${organizationId}/students`,
        {
          params: { ...params, page: pageParam, limit: params.limit || 10 },
        }
      );

      return response.data;
    },
    getNextPageParam: (lastPage) => {
      return lastPage.page < lastPage.totalPages
        ? lastPage.page + 1
        : undefined;
    },
    enabled: !!organizationId,
    ...options,
    initialPageParam: 1,
  });
};

export default useStudentsStats;
